import { RouteLocationNormalized } from "vue-router"

export default (to: RouteLocationNormalized): boolean | undefined => {
  const isDevelopment = process.env.NODE_ENV === "development"
  if (to.name !== "refer" || isDevelopment) return

  const toUrl = new URL(window.location.href)
  toUrl.pathname = "/myaccount/refer"
  window.location.assign(toUrl.toString())
  return false
}
